//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
const APP_KEY = "TUTERIA-V2";

export const isServer = typeof document === "undefined";
const getValue = (key, _default = {}) => {
  let full_key = `${APP_KEY}-${key}`;
  if (isServer) {
    return _default;
  }
  let item = localStorage.getItem(full_key);
  if (item && item !== undefined && item !== "undefined") {
    let result = JSON.parse(item);
    return result;
  }
  return _default;
};

const setValue = (key, value) => {
  let asString = JSON.stringify(value);
  let full_key = `${APP_KEY}-${key}`;
  localStorage.setItem(full_key, asString);
};

const deleteValue = (key) => {
  let full_key = `${APP_KEY}-${key}`;
  localStorage.setItem(full_key, "");
};

export const storage = {
  get: getValue,
  set: setValue,
  clear: deleteValue,
};

export default storage;
